import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

import SiderBarItem from "@/react-components/SiderBar/Item";

class SecondLevelMenu extends React.Component {
  click = (item) => {
    if (item.path) {
      this.selected(item);
    } else {
      item.open = !item.open;
      this.forceUpdate();
    }
  };

  selected = (item) => {
    const { menu, click } = this.props;
    this.unActive();
    item.active = true;
    click && click(menu);
  };

  unActive = () => {
    const { menu } = this.props;
    menu.children.forEach((item1) => {
      item1.path && (item1.active = false);
      item1.children?.length > 0 &&
        item1.children.forEach((item2) => (item2.active = false));
    });
  };

  render() {
    const { menu, t, dismiss, backText } = this.props;
    return (
      <nav className="menu-nav-container">
        <div className="menu-back-container" onClick={dismiss} tabIndex="0">
          <img alt="" src={require("@/assets/images/menu-back.svg")} />
          <div>{backText || t("TWBC0001_back")}</div>
        </div>
        <div className="menu-divider" />
        <div className="nav">
          {menu.children &&
            menu.children.map((item, index) => (
              <React.Fragment key={index}>
                <SiderBarItem item={item} click={() => this.click(item)} />
                {item.open && item.children && item.children.length > 0
                  ? item.children.map((item1, index1) => (
                      <SiderBarItem
                        key={index1}
                        item={item1}
                        click={() => this.selected(item1)}
                        secondLevel
                      />
                    ))
                  : null}
              </React.Fragment>
            ))}
        </div>
      </nav>
    );
  }
}

SecondLevelMenu.propTypes = {
  menu: PropTypes.object.isRequired,
  click: PropTypes.func,
  dismiss: PropTypes.func,
  backText: PropTypes.string,
};

SecondLevelMenu.defaultProps = {
  click: undefined,
  dismiss: undefined,
};

export default withTranslation()(SecondLevelMenu);
